// Default entry point for client scripts
// Automatically generated
// Please avoid from modifying to much...
import * as ReactDOM from "react-dom";
import * as React from "react";
import { App } from "./app";

export const render = (element: HTMLElement) => {
    return ReactDOM.render(React.createElement(App, {}), element);
};
// Automatically added for the recognizeMessageExtension message extension
// export * from "./recognizeMessageExtension/RecognizeMessageExtensionConfig";
// Automatically added for the recognizeMessageExtension message extension action
// export * from "./recognizeMessageExtension/RecognizeMessageExtensionAction";
